import { ConversationFilterStatus } from "./conversationConstant";

export function remapper(data) {
  data.usersId = data.createUsersId?.map((item) => item.id);
  data.adminsId = data.createAdminsId?.map((item) => item.id);
  data.hiddenUsersId = data.createHiddenUsersId?.map((item) => item.id);
  data.mutedUsersId = data.createMutedUsersId?.map((item) => item.id);
  data.disabledUsersId = data.createDisabledUsersId?.map((item) => item.id);
  data.products = data.createProducts?.map((item) => item.products);
  data.tag = data.createTag?.map((item) => item.tag);
}

export function fixGetManyConversations(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      conversationId: resource.objectId,
    })),
  };
}

export function conversationMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      conversationId: resource.objectId,
      adminTag: resource.tag.map((item) => ({tag : item})),
      adminProducts: resource.products.map((item) => ({products : item})),
      conversationStatusName:
          resource.status === 0 || resource.status === 1
              ? getConversationStatus(resource.status)
              : "ایجاد نشده است",
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function conversationMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, conversationId: json.result.objectId, adminTag: json.result.tag.map((item) => ({tag : item})),
      adminProducts: json.result.products.map((item) => ({products : item})),
      conversationStatusName: json.result.status === 0 || json.result.status === 1
              ? getConversationStatus(json.result.status)
              : "ایجاد نشده است",
    }
  };
}

export function getConversationStatus(type) {
  return ConversationFilterStatus[type].name;
}
